import type { ElementType, ReactNode } from 'react';

// 欧文オーバーライン（DESIGN §11.5 / §8.3）。構造の道標として英語ラベルを使う。
// スタイルはグローバルの .overline（base.css）を参照。
type Props = {
  children: ReactNode;
  as?: ElementType;
  className?: string;
};

export default function Overline({ children, as: Tag = 'span', className }: Props) {
  return (
    <Tag className={['overline', className].filter(Boolean).join(' ')}>{children}</Tag>
  );
}
